<div
  class="skymiles-landing-page-menu__sections__section-header"
  [class]="
    details.opened
      ? 'skymiles-landing-page-menu__sections__section-header__opened'
      : ''
  "
  (click)="details.opened = !details.opened"
>
  <a
    [id]="details.id"
    [class]="
      !details.url
        ? 'skymiles-landing-page-menu__sections__section-header__title'
        : 'skymiles-landing-page-menu__sections__section-header__link'
    "
    [href]="details.url"
    [attr.aria-label]="
      !details.url
        ? details.title + ' with ' + details.items.length + ' items '
        : details.title
    "
    (click)="details.url.length || $event.preventDefault()"
  >
    {{ details.title }}
  </a>

  <div
    class="skymiles-landing-page-menu__sections__section-header__icon"
    *ngIf="!details.url"
  >
    <a
      [class]="
        details.opened
          ? 'skymiles-landing-page-menu__sections__section-header__icon--collapse'
          : 'skymiles-landing-page-menu__sections__section-header__icon--expand'
      "
      href="javascript:void(0);"
      role="button"
      [attr.aria-expanded]="details.opened"
      [attr.aria-label]="details.title"
    ></a>
  </div>
</div>
